import React from "react";
import { Icon } from "react-native-elements";

const MenuIcon = ({ navigation }) => {
  return (
    <Icon
      name="menu"
      type="feather"
      color="white"
      size={35}
      style={{ marginTop: 1 }}
      onPress={() => navigation.toggleDrawer()}
    />
  );
};

export default MenuIcon;
